import { ReactNode } from 'react';
import { css } from '@emotion/react';
import { Button, ButtonProps } from '@zapier/marketing-ui';

export type SocialAuthButtonProps = Omit<ButtonProps, 'icon'> & {
  icon: ReactNode;
};

const styles = {
  root: css({
    position: 'relative',
    // The icon is absolutely positioned over the button (16px offset + 20px
    // width), so the centered label needs a matching gutter on both sides or
    // long labels slide under the logo on narrow viewports (CRIT-2904).
    // Symmetric padding keeps the label visually centered.
    paddingLeft: 'var(--zds-space-44, 2.75rem)',
    paddingRight: 'var(--zds-space-44, 2.75rem)',
  }),

  icon: css({
    display: 'flex',
    width: '20px',
    position: 'absolute',
    left: '16px',
  }),
};

/**
 * Wrapper to style SSO buttons (i.e. facebook)
 */
export function SocialAuthButton({
  children,
  icon,
  ...props
}: SocialAuthButtonProps) {
  return (
    <Button {...props} variant="secondary" fullWidth={true} css={styles.root}>
      <div css={styles.icon}>{icon}</div>
      {children}
    </Button>
  );
}
